export const PillTypes = {
  PAYMENTS_TRANSFERS: 'PAYMENTS_TRANSFERS',
  NON_ZERO: 'NON_ZERO',
  NON_MATCHING: 'NON_MATCHING',
  NON_MATCHING_SUPPORT: 'NON_MATCHING_SUPPORT',
};

export const PillDefinitions = [
  { label: 'Payments and Transfers', type: PillTypes.PAYMENTS_TRANSFERS },
  { label: 'Non Zero Balances', type: PillTypes.NON_ZERO },
  { label: 'Non Matching Balances', type: PillTypes.NON_MATCHING },
  { label: 'Non Matching Balances Support', type: PillTypes.NON_MATCHING_SUPPORT },
];

export const getPillDefinitions = () => PillDefinitions;

export const Resources = {
  [PillTypes.PAYMENTS_TRANSFERS]: 'paymentsAndTransfers',
  [PillTypes.NON_ZERO]: 'nonZeroBalances',
  [PillTypes.NON_MATCHING]: 'nonMatchingBalances',
  [PillTypes.NON_MATCHING_SUPPORT]: 'nonMatchingBalancesSupport',
};
